import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { CustomLabelInput } from "../../../../../../../components/input/CustomLabelInput";
import { useState } from "react";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .mergeableFlag-box{
        display: flex;
        flex-direction: column;
        gap: 10px;
        & button{
            border-radius: 3px;
            color: #333;
            &.selected{
                border: 1px solid #333;
            }
        }
    }
    .mergeSeparator-box{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 5px;

        button{
            font-size: 10px;
            height: 30px;
            border-radius: 3px;
            &.selected{
                border: 1px solid #333;
            }
        }
    }
`;

const StyledFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        border: none;
        background: #333;
        color: #fff;
        font-weight: 600;
    }
`;

export function ModalMergeable({
    open,
    onClose,
    targetItem,
    onConfirm
}) {
    const [mergeableFlag, setMergeableFlag] = useState(targetItem?.mergeableFlag || false);
    const [mergeSeparator, setMergeSeparator] = useState(targetItem?.mergeSeparator || '\n');

    const handleSubmit = () => {
        onConfirm({
            ...targetItem,
            mergeableFlag,
            mergeSeparator
        });
        onClose();
    }

    const handleChangeMergeSeparator = (newSeparator) =>{
        setMergeSeparator(newSeparator);
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            병합 여부 선택
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <div className='mergeableFlag-box'>
                        <CustomBlockButton
                            type='button'
                            className={`${mergeableFlag ? 'selected' : ''}`}
                            onClick={() => setMergeableFlag(true)}
                        >
                            병합 사용
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className={`${!mergeableFlag ? 'selected' : ''}`}
                            onClick={() => setMergeableFlag(false)}
                        >
                            병합 사용안함
                        </CustomBlockButton>
                    </div>
                    <div className='mergeSeparator-box'>
                        <CustomBlockButton
                            type='button'
                            className={`${mergeSeparator === '\n' ? 'selected' : ''}`}
                            onClick={()=>handleChangeMergeSeparator('\n')}
                        >
                            줄바꿈(\n)
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className={`${mergeSeparator === '\t' ? 'selected' : ''}`}
                            onClick={()=>handleChangeMergeSeparator('\t')}
                        >
                            들여쓰기(\t)
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className={`${mergeSeparator === ' ' ? 'selected' : ''}`}
                            onClick={()=>handleChangeMergeSeparator(' ')}
                        >
                            띄어쓰기(" ")
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className={`${mergeSeparator === ',' ? 'selected' : ''}`}
                            onClick={()=>handleChangeMergeSeparator(',')}
                        >
                            콤마(,)
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className={`${mergeSeparator === '-' ? 'selected' : ''}`}
                            onClick={()=>handleChangeMergeSeparator('-')}
                        >
                            대시(-)
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className={`${mergeSeparator === '_' ? 'selected' : ''}`}
                            onClick={()=>handleChangeMergeSeparator('_')}
                        >
                            언더바(_)
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className={`${mergeSeparator === '&' ? 'selected' : ''}`}
                            onClick={()=>handleChangeMergeSeparator('&')}
                        >
                            앰퍼샌드(&)
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className={`${mergeSeparator === '|' ? 'selected' : ''}`}
                            onClick={()=>handleChangeMergeSeparator('|')}
                        >
                            파이프(|)
                        </CustomBlockButton>
                    </div>
                </StyledBody>
                <StyledFooter>
                    <CustomBlockButton
                        type='button'
                        onClick={() => handleSubmit()}
                    >
                        적용
                    </CustomBlockButton>
                </StyledFooter>
            </CustomDialog>
        </>
    );
}